<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <base-setting-widget :iteminfo="iteminfo" v-bind="$attrs" v-on="$listeners">
    <div
      class="w-full m-b-10 flex"
    >
      <span class="fs-14 color-33 w-90">轮播类型：</span>
      <RadioGroup class="w-full flex" v-model="iteminfo.config.autoTurn">
        <radio :label="0" size="small" class="m-r-10">
          <span class="fs-14 color-33">自动轮播</span>
        </radio>
        <radio :label="1" size="small" class="m-r-10">
          <span class="fs-14 color-33">手动轮播</span>
        </radio>
      </RadioGroup>
    </div>
    <div class="fs-14 color-33">
      上传图片
    </div>
    <div class="fs-12 color-99 m-v-10" style="margin-right: 0px">
      建议图片尺寸为1242*2688px，图片格式为png或jpg，图片大小不超过5Mb
    </div>
    <ul>
      <li :key="index" class="m-b-10" style="background-color: #F2F2F2"
          v-for="(item,index) in iteminfo.config.datalist">
        <div class="flex" style="min-height: 100px">
          <div class="flex-1 p-v-20 p-l-20">
            <div class="flex" style="min-height: 100px">
              <div class="flex-1 flex a-center j-center"
                   v-if="iteminfo.config.displayType===1">
                <img :src="getItemUrl(item)" alt="" style="width: 100%;height: 115px"
                     @click="showModal(item)">
                <!--                <up-load-image @uploadSuccess="uploadcoversuccess($event,item)" accept="image/*"-->
                <!--                               picurl="crop/crop/"-->
                <!--                               style="width: 100%;height: 115px">-->
                <!--                  <template v-slot:tip>-->
                <!--                    <div class="bg-white border" style="width: 100%;height: 115px">-->
                <!--                      <div class="o-hidden flex a-center" style="width: 100%;height: 115px">-->
                <!--                        <img :src="getItemUrl(item)" alt="" class="w-full">-->
                <!--                      </div>-->
                <!--                    </div>-->
                <!--                  </template>-->
                <!--                </up-load-image>-->
              </div>
              <div class="flex-1 flex a-center" v-if="iteminfo.config.displayType===2">
                <img :src="getItemUrl(item)" alt="" style="width: 80px;height: 80px"
                     @click="showModal(item)">
                <!--                <up-load-image @uploadSuccess="uploadcoversuccess($event,item)" accept="image/*"-->
                <!--                               picurl="crop/crop/"-->
                <!--                               style="width: 80px;height: 80px">-->
                <!--                  <template v-slot:tip>-->
                <!--                    <div class="bg-white border o-hidden flex a-center j-center"-->
                <!--                         style="width: 80px;height: 80px">-->
                <!--                      <img :src="getItemUrl(item)" alt="" style="width: 100%;">-->
                <!--                    </div>-->
                <!--                  </template>-->
                <!--                </up-load-image>-->
                <div class="flex-1 p-l-10 flex-column" style="height: 80px;align-items: flex-start">
                  <Input class="b-r" placeholder="导航名称" style=""
                         v-model="item.title"></Input>
                  <Input class="m-t-10" placeholder="链接">
                    <span slot="append">  <i class="icon-link"/> </span>
                  </Input>
                </div>
              </div>

              <div class="flex-1"
                   v-if="iteminfo.config.displayType===3">
                <div style="height: 250px;background: #F2F2F2"
                     class="flex flex-1 j-center">
                  <div v-if="!item.picurl" class="bg-white h-full flex-column"
                       @click="choicePic(item)"
                       style="width: 140px">
                    <Icon color="#cccccc" size="40" type="ios-add"/>
                    <span class="fs-12">上传图片</span>
                  </div>
                  <img v-if="item.picurl" :src="item.picurl" alt=""
                       @click="choicePic(item)"
                       style="width: 140px;height: 100%;">
                </div>

                <!--                全屏跳转链接设置-->
                <div class="bg-white flex border m-t-10" style="height: 34px;"
                >
                  <Input :border="false" class="b-r" placeholder="标题名称" style="width: 100px"
                         v-model="item.jumpObj.linkName"></Input>
                  <tooltip style="width: 100%"
                           :disabled="!item.jumpObj.linkUrl"
                           max-width="250">

                    <Input :border="false"
                           class="input-link"
                           readonly clearable
                           width="200"
                           placeholder="跳转链接地址" v-model="item.jumpObj.linkUrl">
                  <span slot="append" style="cursor: pointer"
                        @click="showMaterialModal(item,index)">  <i class="icon-link"/> </span>
                    </Input>
                    <div slot="content" style="white-space: normal;">
                      {{ item.jumpObj.linkUrl }}
                    </div>
                  </tooltip>
                </div>
                <!--                <up-load-image @uploadSuccess="uploadcoversuccess($event,item)" accept="image/*"-->
                <!--                               picurl="crop/crop/"-->
                <!--                               style="width: 100%;height: 250px">-->
                <!--                  <template v-slot:tip>-->
                <!--                    <div style="width: 100%;height: 250px;background: #F2F2F2"-->
                <!--                         class="flex j-center">-->
                <!--                      <div v-if="!item.picurl" class="bg-white h-full flex-column"-->
                <!--                           style="width: 140px">-->
                <!--                        <Icon color="#cccccc" size="40" type="ios-add"/>-->
                <!--                        <span class="fs-12">上传图片</span>-->
                <!--                      </div>-->
                <!--                      <img v-if="item.picurl" :src="item.picurl" alt=""-->
                <!--                           style="width: 140px;height: 100%;">-->
                <!--                    </div>-->
                <!--                  </template>-->

                <!--                </up-load-image>-->
              </div>
              <div class="flex a-center">
                <div class="flex-column a-center flex-s-0"
                     style="width: 50px;justify-content: space-around;min-height: 120px">
                  <i :style="{color:getUpColor(index)}" @click.stop="onUpClick(index)"
                     class="icon-up fs-18"
                     style="cursor: pointer;"/>
                  <i :style="{color:getDownColor(index,iteminfo.config.datalist.length)}"
                     @click.stop="onDownClick(index)"
                     class="icon-down fs-18"
                     style="cursor: pointer;"/>
                  <i @click.stop="onDelClick(index)" class="icon-delete_facet fs-18"
                     style="cursor: pointer;color: #666666"/>
                </div>
              </div>
            </div>
            <div class="bg-white flex border m-t-10" style="height: 34px;margin-right: 50px;"
                 v-if="false">
              <!--                 v-if="iteminfo.config.displayType===1 || iteminfo.config.displayType===3">-->
              <Input :border="false" class="b-r" placeholder="导航名称" style="width: 100px"
                     v-model="item.title"></Input>
              <Input :border="false" placeholder="链接">
                <span slot="append">  <i class="icon-link"/> </span>
              </Input>
            </div>
          </div>

        </div>
      </li>
      <li @click="onItemAddClick" class="flex a-center j-center m-v-10" key="abc"
          style="height: 48px;border:1px dashed #D8D8D8;cursor: pointer;background-color: #F2F2F2">
        <Icon size="24" type="ios-add"/>
        <div class="m-l-2">添加图片</div>
        <!--        <div class="m-l-2">添加{{ iteminfo.name }}图片</div>-->
      </li>
    </ul>

    <materail-choice-weidget
      title="选择链接"
      :on-ok="materialChoiceOk"
      ref="materialChoiceWidget"/>

    <pic-choice-widget
      ref="picChoiceWidget"
      :on-ok="picChoiceOk"
    />

  </base-setting-widget>
</template>

<script>
import BaseSettingWidget from '../base/BaseSettingWidget'
import UpLoadImage from '../../common/UpLoadImage'
import PicChoiceWidget from '@/components/common/chiose/PicChoiceWidget'
import MaterailChoiceWeidget from '@/components/common/chiose/MaterialChoiceWidget'

export default {
  name: 'GuideSettingWidget',
  components: {MaterailChoiceWeidget, PicChoiceWidget, UpLoadImage, BaseSettingWidget},
  props: {
    iteminfo: Object
  },
  data () {
    return {
      showPicChoiceModal: false,
      clickedItem2ShowModal: 0,
      clickItem2ShowMaterialModal:null,
      datalist: [],
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
    },
    onItemAddClick () {
      this.iteminfo.config.datalist.push({
        id: 0,
        picurl: '',
        title: '',
        jumpObj:{
          linkName:'',
          linkUrl:''
        }
      })
    },
    onUpClick (index) {
      if (index > 0) {
        let item = this.iteminfo.config.datalist[index - 1]
        this.iteminfo.config.datalist.splice(index - 1, 1)
        this.iteminfo.config.datalist.splice(index, 0, item)
      }
    },
    onDownClick (index) {
      if (index < (this.iteminfo.config.datalist.length - 1)) {
        let item = this.iteminfo.config.datalist[index + 1]
        this.iteminfo.config.datalist.splice(index + 1, 1)
        this.iteminfo.config.datalist.splice(index, 0, item)
      }
    },
    onDelClick (index) {
      this.iteminfo.config.datalist.splice(index, 1)
    },
    // uploadcoversuccess (data, item) {
    //   if (data && data.length) {
    //     item.picurl = data[0].url
    //   }
    // },
    getItemUrl (item) {
      let src = require('../../../assets/tempmenu/img_picture_abreast.png')
      if (this.iteminfo.config.displayType === 1) {
        src = require('../../../assets/tempmenu/img_nav_card.png')
      } else if (this.iteminfo.config.displayType === 2) {
        src = require('../../../assets/tempmenu/img_nav_icon.png')
      } else if (this.iteminfo.config.displayType === 3) {
        src = require('../../../assets/tempmenu/img_carousel.png')
      }
      if (item.picurl) {
        src = item.picurl
      }
      return src
    },
    getUpColor (index) {
      if (index === 0) {
        return '#BBBBBB'
      } else {
        return '#666666'
      }
    },
    getDownColor (index, length) {
      if (length === 0 || index === length - 1) {
        return '#BBBBBB'
      } else {
        return '#666666'
      }
    },
    showModal (item) {
      this.clickedItem2ShowModal = item
      this.showPicChoiceModal = true
    },
    uploadcoversuccess (data) {
      if (data && data.length) {
        this.clickedItem2ShowModal.picurl = data[0].url
        this.showPicChoiceModal = false
      }
    },
    onPicModalOk () {
      this.datalist.forEach(item => {
        if (item.isSelected) {
          this.clickedItem2ShowModal.picurl = item.imgUrl
          this.showPicChoiceModal = false
        }
      })
    },

    itemClick (item, i) {

      this.datalist.forEach((item, index) => {
        if (i !== index) {
          item.isSelected = false
        }
      })
      item.isSelected = !item.isSelected
    },
    itemDelete (item, index) {
      this.$Modal.confirm({
        title: '提示',
        content: '确定要删除吗?',
        onOk: () => {
          this.datalist.splice(index, 1)
        },
      })
    },
    copy (e) {
      this.$Message.info('复制成功')
    },
    copyOnError (e) {
      this.$Message.info('复制失败')
    },
    choicePic (item) {
      this.clickItem2ShowPicModal = item
      this.$refs.picChoiceWidget.show()
    },
    picChoiceOk (data) {
      if (data && data.length) {
        let pic = data[0]
        this.clickItem2ShowPicModal.picurl = pic.url
        //图片选择,选择图片时,需要上传这个链接;非选择图片,需要为空
        this.clickItem2ShowPicModal.contentLink = pic.linkurl
        this.clickItem2ShowPicModal.title = pic.title
        this.clickItem2ShowPicModal.width = pic.width
        this.clickItem2ShowPicModal.height = pic.height
      }
    },
    showMaterialModal (row, index) {
      this.clickItem2ShowMaterialModal = row
      this.$refs.materialChoiceWidget.show()
    },
    materialChoiceOk (data) {
      this.clickItem2ShowMaterialModal.jumpObj.linkUrl = data[0].url
    },
  }
}
</script>

<style lang="scss" scoped>
.modal-setting ::v-deep {

  .ivu-modal-body {
    padding: 0;
    display: flex;
    justify-content: center;
    align-content: center;
  }

  //标题下横线
  .ivu-modal-header {
    border-bottom: none;
  }

  //确认取消按钮上面红线
  .ivu-modal-footer {
    border-top: none;
  }
}

.list-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: flex-start;
  flex-wrap: wrap;
  overflow-x: hidden;
}

.item {
  width: 140px;
  height: 170px;
  flex-direction: row;
  margin-bottom: 10px;
}

.item-selected {
  //border-color: #0EA4FB;
  //border-width: 2px;
  border: 2px solid #0EA4FB;
}

.item-normal {
  //border-color: #0EA4FB;
  //border-width: 2px;
  border: 2px solid white;
}

.item-editable {
  display: none;
}

.item:hover .item-editable {
  display: flex;
}

.lin2 {
  color: #333;
  max-width: 600px;
  font-size: 13px;
  line-height: 20px;
  //height: 40px;
  //margin-top: 6px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
  -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
  -webkit-line-clamp: 2; /** 显示的行数 **/
  overflow: hidden; /** 隐藏超出的内容 **/
}


.triangle {
  width: 0;
  height: 0;
  border-color: transparent #0F8CFB;
  border-width: 0 25px 25px 0;
  border-style: solid;
}
</style>
